// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u4WM","title":"styles_title__uPEIu"};